import { createAsyncThunk } from '@reduxjs/toolkit';
import AgentManagementService from '@/services/AgentManagementService';
import ApiService from '@/services/ApiService';

// eslint-disable-next-line import/prefer-default-export
export const createAgent = createAsyncThunk(
  'CreateAgent/createAgent',
  async (payload, { rejectWithValue }) => {
    try {
      return await AgentManagementService.createAgent(payload);
    } catch (error) {
      // The service skips the 403 redirect so the plan's user limit, sent as
      // `{ error }`, reaches the form. Any other 403 is a lost session or a
      // non-admin user, so redirect as every other endpoint does.
      const isPlanLimit = error.status === 403 && !!error.response?.error;
      if (error.status === 403 && !isPlanLimit) {
        return ApiService.stopAfterUnauthorizedRedirect();
      }
      return rejectWithValue({
        errors: error.response?.errors,
        // 500s also answer `{ error }`, but with nothing readable.
        message: isPlanLimit ? error.response.error : null,
      });
    }
  }
);
